import mapboxgl from 'mapbox-gl';
import { map, reduce, get } from 'lodash';
import VueI18n from 'services/i18n';

/**
 * Create a GeoJSON object from an array of items with id and location properties
 *
 * @param {[{id: *, location:{longitude: Number, latitude: Number}}]} items
 * @returns {{type: string, features: ReadonlyArray<any>}}
 */
export function makePoints(items) {
  const features = map(items, item => {
    const longitude = get(item, 'location.longitude');
    const latitude = get(item, 'location.latitude');

    if (!longitude || !latitude) {
      return;
    }

    return {
      type: 'Feature',
      properties: {
        id: item.id,
        type: item._presentEventType,
      },
      geometry: {
        type: 'Point',
        coordinates: [longitude, latitude],
      },
    };
  });

  return {
    type: 'FeatureCollection',
    features: Object.freeze(features.filter(e => e)),
  };
}

/**
 * Create a Mapbox LngLat Bonuds object from points
 *
 * @param points
 * @returns {*}
 */
export function makeBounds(points) {
  const coordinates = map(
    points.features,
    feature => feature.geometry.coordinates
  );
  return reduce(
    coordinates,
    (bounds, coord) => {
      return bounds.extend(coord);
    },
    new mapboxgl.LngLatBounds(coordinates[0], coordinates[0])
  );
}

export const actions = {
  NORMAL: 'NORMAL',
  SPEEDING: 'SPEEDING',
};
export function splitWaypoints(waypoints, coordFn) {
  return waypoints
    .reduce((acc, curr) => {
      const { speed, speed_limit, latitude, longitude } = curr;
      const parsedCoords = coordFn({ latitude, longitude });
      const action =
        speed_limit && speed > speed_limit ? actions.SPEEDING : actions.NORMAL;
      const [prevAction, ...otherActions] = acc;

      if (!prevAction) {
        return [{ action, waypoints: [parsedCoords] }];
      }

      if (prevAction.action !== action) {
        const closedPrevAction = {
          ...prevAction,
          waypoints: [...prevAction.waypoints, parsedCoords],
        };

        return [
          {
            action,
            waypoints: [parsedCoords],
          },
          closedPrevAction,
          ...otherActions,
        ];
      }

      return [
        {
          ...prevAction,
          waypoints: [...prevAction.waypoints, parsedCoords],
        },
        ...otherActions,
      ];
    }, [])
    .reverse();
}

export const getAudienceMapLegendItems = () => [
  {
    title: VueI18n.t('audience.map.in_transport'),
    color: '#3a99fc',
  },
  {
    title: VueI18n.t('audience.map.stationary'),
    color: '#e57373',
  },
];

export const getTripMapLegendItems = () => [
  {
    title: VueI18n.t('trip.map.normal'),
    color: '#5886e1',
  },
  {
    title: VueI18n.t('trip.map.speeding'),
    color: '#e57373',
  },
];

export const pointsLayer = {
  id: 'points',
  type: 'circle',
  source: {
    type: 'geojson',
    data: null,
  },
  paint: {
    'circle-radius': 3,
    'circle-opacity': 1,
    'circle-color': [
      'match',
      ['get', 'type'],
      'Stationary',
      '#e57373',
      'Transport',
      '#3a99fc',
      /* other */ '#3a99fc',
    ],
    'circle-stroke-width': 1,
    'circle-stroke-color': '#fff',
  },
};
